import React, { createContext, useMemo, useState } from 'react';

export const VoiceBotStateContext = createContext();
export const VoiceBotDispatchContext = createContext();

const initialState = {
    audioFileIndex: -1, // Index of the current audio file
    isListening: false, // Boolean to track if voice recognition is active
    voiceBotText: "", // Text of the VoiceBot
    sentences: [], // Array of sentences
    combinedText: "", // Combined text of interviewer and user
    prevCombinedText: "", // Previous combined text
  };
  

export const VoiceBotStateProvider = ({ children }) => {
  const [voiceBotState, setVoiceBotState] = useState(initialState);
  const value = useMemo(
    () => ({ voiceBotState, setVoiceBotState }),
    [voiceBotState]
  );

  return (
    <VoiceBotDispatchContext.Provider value={setVoiceBotState}>
      <VoiceBotStateContext.Provider value={value}>
        {children}
      </VoiceBotStateContext.Provider>
    </VoiceBotDispatchContext.Provider>
  );
};
